var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profil-container"},[(_vm.is_catatan_head_open)?_c('need-review',{attrs:{"title":'Need Review',"modalClose":_vm.closeReviewHead,"submit":_vm.needReviewHead}}):_vm._e(),(_vm.is_catatan_open)?_c('need-review',{attrs:{"title":'Need Review SIPM',"modalClose":_vm.close,"submit":_vm.needReviewHSE}}):_vm._e(),_c('block-label',{attrs:{"label":'HASIL PENILAIAN SEMENTARA'}}),_c('form-result-kplh',{attrs:{"tables":_vm.tableInput.inputForm1,"listInput":[
      {
        type: 'text',
        name: 'Kritis',
        // t_bobot: tableResiko.kritis,
        t_bobot: _vm.bobot_kritis,
        t_nilai: _vm.total_kritis,
        p_nilai: ((_vm.countValue().toFixed(2)) + " %"),
        p_lulus: "75 %",
        note:
          _vm.countValue() >= 75
            ? 'LULUS PRAQUALIFIKASI'
            : 'TIDAK LULUS PRAQUALIFIKASI',
      },
      {
        type: 'text',
        name: 'Tinggi',
        // t_bobot: tableResiko.tinggi,
        t_bobot: _vm.bobot_tinggi,
        t_nilai: _vm.total_tinggi,
        p_nilai: ((_vm.countValue().toFixed(2)) + " %"),
        p_lulus: "75 %",
        note:
          _vm.countValue() >= 75
            ? 'LULUS PRAQUALIFIKASI'
            : 'TIDAK LULUS PRAQUALIFIKASI',
      },
      {
        type: 'text',
        name: 'Sedang',
        // t_bobot: tableResiko.sedang,
        t_bobot: _vm.bobot_sedang,
        t_nilai: _vm.total_sedang,
        p_nilai: ((_vm.countValue().toFixed(2)) + " %"),
        p_lulus: "75 %",
        note:
          _vm.countValue() >= 75
            ? 'LULUS PRAQUALIFIKASI'
            : 'TIDAK LULUS PRAQUALIFIKASI',
        options: [0, 1, 2, 3],
      },
      {
        type: 'text',
        name: 'Rendah',
        // t_bobot: tableResiko.rendah,
        t_bobot: _vm.bobot_rendah,
        t_nilai: _vm.total_rendah,
        p_nilai: ((_vm.countValue().toFixed(2)) + " %"),
        p_lulus: "75 %",
        note:
          _vm.countValue() >= 75
            ? 'LULUS PRAQUALIFIKASI'
            : 'TIDAK LULUS PRAQUALIFIKASI',
      } ],"modelName":'addedIUJP',"isRequired":false,"mutationName":'kplhStore/SET_KPLH_FORM',"storeName":'kplhStore',"modalName":'modal_add_iujp',"disabled":_vm.is_hse_validation || _vm.is_preview}}),_c('block-label',{attrs:{"label":'HASIL PENILAIAN FINAL'}}),_c('form-result-kplh',{attrs:{"tables":_vm.tableInput.inputForm2,"listInput":[
      {
        type: 'form',
        t_resiko: _vm.$tingkatResikoValue(),
        t_bobot: _vm.total_bobot,
        p_nilai: ((_vm.countValue().toFixed(2)) + " %"),
        notes_options: _vm.notes_options,
        head_hse_options: _vm.head_hse_options,
        ktt_options: _vm.ktt_options,
      } ],"modelName":'addedIUJP',"isRequired":false,"mutationName":'kplhStore/SET_KPLH_FORM',"storeName":'kplhStore',"modalName":'modal_add_iujp',"disabled":_vm.is_hse_validation || _vm.is_preview}}),_c('div',{staticClass:"vendor-form-wrapper"},[_c('input-text-area',{attrs:{"label":'Catatan',"modelName":'catatan',"isRequired":false,"mutationName":'kplhStore/SET_KPLH_FORM',"storeName":'kplhStore',"disabled":_vm.is_hse_validation || _vm.is_preview}})],1),_c('div',{staticClass:"profil-btn-wrapper"},[(_vm.buttonDisabled('hse'))?_c('div',{staticClass:"btn-landing",on:{"click":function($event){return _vm.open()}}},[_vm._v(" Need Review SIPM ")]):_vm._e(),(_vm.buttonDisabled('hse'))?_c('div',{staticClass:"btn-landing",on:{"click":function($event){return _vm.submitNilai()}}},[_vm._v(" Submit Nilai ")]):_vm._e(),(_vm.buttonDisabled('head'))?_c('div',{staticClass:"btn-landing",on:{"click":function($event){return _vm.approveHead()}}},[_vm._v(" Approve ")]):_vm._e(),(_vm.buttonDisabled('head'))?_c('div',{staticClass:"btn-landing",on:{"click":function($event){return _vm.openReviewHead()}}},[_vm._v(" Need Review ")]):_vm._e(),_c('div',{staticClass:"btn-landing",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Kembali")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }